import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import {translationsEn} from './english';
import {translationsKa} from './georgian';


const resources = {
  en: {
    translation: translationsEn,
  },
  ka: {
    translation: translationsKa,
  },
};

i18next
  .use(initReactI18next)
  .init({
    resources,
    lng: document.querySelector('html').lang,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;